export enum CartCounterButtonEnum {
    FULL = 'full',
    COUNTER = 'counter',
}
